<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-02 15:37 -->
<!-- Description:  -->
<template>
  <div>
    <HoraryForm ref="elHorary" :content="schedule" 
      :key="schedule.id" @saved="handlerAfterSave($event)"
      :employee_id="employee_id"></HoraryForm>
  </div>
</template>
<script>
// script content
import AdminService from "src/lt/admin-module/AdminService.js";
import HoraryForm from "./horary/HoraryForm.vue";

export default {
  name: "EmployeeHorary",
  components: {
    HoraryForm
  },

  // directives

  props: {
    employee_id: {},
  },

  data: () => ({
    schedule: {},
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.getLastSchedule();
  },

  methods: {
    async getLastSchedule() {
      let res = await AdminService.getEmployeeSchedules({
        per_page: 1,
        employee_id: this.employee_id,
      });
      if(res.data.length > 0) {
        this.schedule = res.data[0];
      }
    },
    handlerAfterSave(ev) {
      if(!this.schedule.id) {
        this.$emit('saved', ev);
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

